
import { Component, Vue } from 'vue-property-decorator';
import Layout from '@/components/layout/Layout.vue';
import {ApiRepository} from '@/api';
import ApplicationCounter from '@/components/home/ApplicationCounter.vue';


@Component({
  components: {
    ApplicationCounter,
    Layout,
  },
})
export default class Home extends Vue {
  private statusCounts: Object = {
    new: 0,
    approved: 0,
    cancelled: 0
  };

  public async mounted() {
    this.statusCounts = await ApiRepository.getPartnerStatusCounts();
  }
  
}
